export const ModalMessage = {
  requestUserAccessData: {
    title: "Request User Access Data",
    getConfirmationMsg(gitsProductTeamEmail) {
      return (
        <span>
          <span>Please confirm if you would like to notify </span>
          <span style={{ fontWeight: 700 }}>{gitsProductTeamEmail}</span>
          <span> to get the latest user access data. </span>
        </span>
      );
    },
    okText: "Confirm",
  },
  preview: { title: "Preview" },
  startReview: {
    title: "Preview and Start Review",
    getConfirmationMsg(assignedTaskLength, totalTaskLength) {
      return (
        <>
          <>
            <span className="assigned-task-start-review">Assigned Tasks / Total Tasks : </span>
            <span className="assigned-task-start-review-value">{`${assignedTaskLength} of ${totalTaskLength}`}</span>
          </>
          <br />I confirm that I have the latest user access data to start the review process
        </>
      );
    },
    okText: "Start review",
  },
  closeReview: {
    title: "Close Review",
    confirmationMsg: (
      <span>Are you sure you want to close the review?</span>
    ),
    ticketConfirmationMsg(ticketCount) {
      return (
        <span>
          There are {ticketCount} open zendesk tickets!
        </span>
      );
    },
    okText: "Yes, Close review",
  },
  cancelReview: {
    title: "Cancel Review",
    confirmationMsg: (
      <span>Are you sure you want to cancel the review?</span>
    ),
    ticketConfirmationMsg(ticketCount) {
      return (
        <span>
          There are {ticketCount} open zendesk tickets!
        </span>
      );
    },
    okText: "Yes",
  },
  sendReminderEmail: {
    title: "Send Reminder",
    confirmationMsg: (
      <span>
        <span>Are you sure to send the reminder email to all </span>
        <span style={{ fontWeight: 700 }}>Global Access Approvers</span>
        <span> and </span>
        <span style={{ fontWeight: 700 }}>Access Owners</span>
        <span> with pending tasks?</span>
      </span>
    ),
  },
  closeTabWithEditedEntries: {
    title: "Are you sure you want to close this tab?",
    confirmationMsg: "You have some edited entries that need to be submitted.",
  },
};
